import {
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  ToastrService,
  ExportService,
  LoggingService,
  GlobalSearchTermsData,
  GlobalSearchTermDataPoint,
} from "app/shared";
import { BaseChartLogic } from "app/analytics/BaseChartLogic";
import { GlobalSearchTermsConfig } from "app/shared/model/charts/user-analytic-configurations.model";

@Component({
  selector: "global-search-term-chart",
  templateUrl: "../../common-chart-template.component.html",
  standalone: false,
})
export class GlobalSearchTermChartComponent
  extends BaseChartLogic<GlobalSearchTermsConfig, GlobalSearchTermsData>
  implements OnInit, OnDestroy
{
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;
  @Input() showTitle: boolean = true;
  @ViewChild("chartCanvas") chartCanvas!: ElementRef<HTMLCanvasElement>;

  constructor(
    _analyticsService: AnalyticsService,
    _authService: AuthorizationService,
    _exportService: ExportService,
    _toastrService: ToastrService,
    _loggingService: LoggingService,
    _ngZone: NgZone
  ) {
    super(
      _analyticsService,
      _authService,
      _exportService,
      _toastrService,
      _loggingService,
      GlobalSearchTermsConfig,
      _ngZone
    );
    this.handleDataSubscription(this.analyticsService.globalSearchTermsDataChange);
  }

  dataPointKey: string = "Total";
  protected getDataPointDisplayValue(dataPoint: GlobalSearchTermDataPoint): any {
    return dataPoint.Total;
  }

  buildFilterSettings(): void {
    this.addPeriodtoFilterSettings();
    this.addStartEndDatesToFilterSettings(this.startDate, this.endDate);
    this.filterSettings.FilterByMinimum = this.config?.minUsed || null;
  }

  refreshData(): void {
    this.analyticsService.getGlobalSearchTermsData(this.filterSettings);
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }
}